import { useState } from 'react'
import { format, isValid } from 'date-fns'

import { DatePicker, DateValidationError, LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import { FieldChangeHandler } from '@mui/x-date-pickers/internals'

import { FilterType } from '../../base/FilterableTable/FilterableTable.types'

type Props = {
  onFilterSelect: (value: FilterType) => void
  width?: string | number
  label: string
  minDate?: Date
  maxDate?: Date
  dateFormat?: string
  roundTo: 'start' | 'end'
}

export const DateFilter = ({
  label,
  onFilterSelect,
  dateFormat = 'dd MMM yyyy',
  minDate,
  maxDate,
  width,
  roundTo
}: Props) => {
  const [open, setOpen] = useState(false)

  const handleChange: FieldChangeHandler<Date | null, DateValidationError> = (date) => {
    setOpen(false)

    if (date && isValid(date)) {
      switch (roundTo) {
        case 'start':
          date.setHours(0, 0, 0, 0)
          break
        case 'end':
          date.setHours(23, 59, 59, 59)
          break
      }
    }

    const option =
      date && isValid(date)
        ? {
            value: date.toISOString(),
            label: format(date, dateFormat)
          }
        : null

    if (option) onFilterSelect?.(option)

    setTimeout(() => {
      ;(document?.activeElement as HTMLElement).blur()
    }, 0)
  }

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <DatePicker
        label={label}
        value={null}
        open={open}
        onChange={handleChange}
        format={dateFormat}
        maxDate={maxDate}
        onClose={() => setOpen(false)}
        minDate={minDate}
        slotProps={{
          textField: {
            size: 'small',
            onClick: (e: React.MouseEvent) => {
              e.stopPropagation()
              setOpen(true)
            },
            focused: false
          },
          openPickerButton: {
            onClick: (e: React.MouseEvent) => {
              e.stopPropagation()
              setOpen(true)
            }
          }
        }}
        sx={{
          width: width ?? 150
        }}
      />
    </LocalizationProvider>
  )
}
